import type { IStoryblokPageData } from '@/stores/types'
import { setMainHeaderActiveTabByPage } from '@/composables/main-header/setActiveTabByPage'

export const useInitPage = async (page: string) => {
  const { locale, t } = useI18n()

  const { data: pageStory, error } = await useFetch<IStoryblokPageData>(`/api/storyblok/${page}`, {
    query: { language: locale.value }
  })

  setMainHeaderActiveTabByPage(page)

  if (error.value) {
    console.error(`Error fetching ${page} data:`, error.value)
    useRobotsRule(false)
    throw createError({
      statusCode: error.value.statusCode ?? 404,
      statusMessage: error.value.statusMessage ?? t('global.error.pageNotFound')
    })
  }

  return pageStory
}
